var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMiniDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3302 0C19.0449 0 24.4885 5.44361 24.4885 12.1583C24.4885 18.873 19.0449 24.3167 12.3302 24.3167C5.61549 24.3167 0.171875 18.873 0.171875 12.1583C0.171875 5.44361 5.61549 0 12.3302 0ZM18.3265 8.50162L15.9869 6.16206L12.3394 9.80956L8.69193 6.16206L6.35236 8.50162L9.99986 12.1491L6.35236 15.7966L8.69193 18.1362L12.3394 14.4887L15.9869 18.1362L18.3265 15.7966L14.679 12.1491L18.3265 8.50162ZM12.3302 3.31591C17.212 3.31591 21.1634 7.27657 21.1634 12.1583C21.1634 17.0401 17.212 21.0007 12.3302 21.0007C7.44845 21.0007 3.49699 17.0401 3.49699 12.1583C3.49699 7.27657 7.44845 3.31591 12.3302 3.31591Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniDelete);
export default __webpack_public_path__ + "static/media/mini-delete.a284949f082fc2ce42c30c5b569e2138.svg";
export { ForwardRef as ReactComponent };